<div [style.text-align]="textAlign">
    <div [ngStyle]="topRowStyle" class="top-row">
        <span *ngIf="greenCircleIcon" class="dotGreen"></span>
        <span *ngIf="grayCircleIcon" class="dotGray"></span>
        <span>{{ label }}</span>

        <lsq-icon-popover
            *ngIf="!!tooltipText"
            class="pay-later-label-popover text-left"
            [hover]="true"
            [placement]="tooltipPlacement"
            [text]="tooltipText"
        >
        </lsq-icon-popover>
    </div>
    <div class="amount-value" [style.margin-right]="!!tooltipText ? '2.2rem' : '0'">
        <ng-content></ng-content>
    </div>
    <div *ngIf="divideLine" class="divider"></div>
</div>
